import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { RateManagerService } from '@app/_components/rate/rate-manager';
import { AlertService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { CalendarModule } from 'primeng/calendar';
import * as moment from 'moment';

@Component({
    selector: 'app-rate-manager',
    templateUrl: './rate-manager.component.html',
    styleUrls: ['./rate-manager.component.css'],
    standalone: false
})
export class RateManagerComponent implements OnInit
{

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private rateManagerService: RateManagerService,
		private alertService: AlertService,
		private location: Location,
		private formBuilder: UntypedFormBuilder) { }

	// structure
	subscription: Subscription;
	routerLocation = this.location;


	// data
	rateManagerApiResponse: ApiResponse;
	rateManager;
	rateManagerId: number;


	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;

	validationMessages = {
		'effectiveDate': [
			{ type: 'required', message: 'Required' },
			{ type: 'maxlength', message: '15 characters maximum' }],
		'effectiveRate': [
			{ type: 'required', message: 'Required' },
			{ type: 'maxlength', message: '15 characters maximum' }]
	};


	ngOnInit()
	{

		// formAction
		this.formAction = this.router.url.startsWith('/rate-manager-add') ? 'add' : this.router.url.startsWith('/rate-manager-edit') ? 'edit' : this.router.url.startsWith('/rate-manager-view') ? 'view' : '/';

        /**
         *
         *
         *
         * DATA
         *
        */

		// -------------------------------------------------------------------------------------------------
		// no advanced data handlers
		// -------------------------------------------------------------------------------------------------


        /**
         *
         *
         *
         * ACTIONS (ADD / EDIT / DETAIL)
         *
         */

		// dashboard
		this.formBuild();



		try
		{
			// add
			if (this.formAction === 'add')
			{
				this.formLabels['title'] = 'Add New Rate Manager';
				this.formReadOnly = false;
				this.formBuild();
			}

			// edit
			else if (this.formAction === 'edit')
			{

				this.subscription = this.activatedRoute.params.subscribe(params =>
				{
					this.rateManagerId = params.rateManagerId; // (+) converts string 'id' to a number
				});
				this.formLabels['title'] = 'Edit';
				this.formReadOnly = false;
				this.formBuild();

				// get data
				this.rateManager = this.findById(+this.rateManagerId);

				// patch in data
				this.form1.patchValue(this.rateManager);
			}

			// view
			else if (this.formAction === 'view')
			{
				this.subscription = this.activatedRoute.params.subscribe(params =>
				{
					this.rateManagerId = params.rateManagerId; // (+) converts string 'id' to a number
				});
				this.formLabels['title'] = '';
				this.formReadOnly = true;
				this.formBuild();

				// get data
				this.rateManager = this.findById(+this.rateManagerId);

				// patch in data
				this.form1.patchValue(this.rateManager);
			}
		}
		catch (error)
		{
			console.log('Error: ' + error);
		}
	}


	formBuild()
	{
        /**
           *
           *
           *
           * FORM
           *
           */

		this.form1 = this.formBuilder.group({
			rateManagerId: [this.rateManagerId],
			createDate: [],
			lastUpdate: []



			// name: ['', Validators.compose([Validators.required, Validators.maxLength(15)])],
			// description: ['', Validators.compose([Validators.required, Validators.maxLength(128)])]
		});
	}


	formAdd()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}

			this.formLoading = true;

			this.rateManagerService.add(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('rate-manager-add SUCCESS: ' + JSON.stringify(res));
						this.rateManagerId = res.data.rateManager.rateManagerId;
						this.router.navigate(['/rate-manager-view', this.rateManagerId]);
					},
					err =>
					{
						console.log('rate-manager-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	formUpdate()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}
			console.log('rate-manager-before-updateS: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;

			this.rateManagerService.update(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('rate-manager-update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.router.navigate(['/rate-manager-view', this.rateManagerId]);
					},
					err =>
					{
						console.log('rate-manager-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	findById(id: number)
	{
		try
		{
			this.formLoading = true;
			this.rateManagerService.findById(id)
				.subscribe(
					res =>
					{
						console.log('rate-manager-find SUCCESS: ' + JSON.stringify(res));
						this.rateManagerApiResponse = res;
						this.rateManager = res.data.rateManager;
						this.form1.patchValue(this.rateManager);
					},
					err =>
					{
						console.log('rate-manager-find FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

}
